<template>
  <p class="trademark" v-html="$t('trademark')" />
</template>
<script>
import localeCommon from '@locales/common'

export default {
  $messages: localeCommon,
}
</script>
<style lang="scss" scoped>
.trademark {
  padding: 30px 20px;
}
</style>
